import { useTranslation } from 'libs/i18n';
import { Section } from 'modules/client/common/components';

import { FormContent } from './FormContent';

export const InvestmentPurposeAndNatureSection = () => {
  const { t } = useTranslation();

  return (
    <Section
      datax="investmentPurposeAndNatureSection"
      title={t('client.legal.investmentPurposeAndNature.title')}
    >
      <FormContent />
    </Section>
  );
};
